export { default } from "./GameTable.web";
